import { render, staticRenderFns } from "./RoutesList.vue?vue&type=template&id=95102796&"
import script from "./RoutesList.vue?vue&type=script&lang=js&"
export * from "./RoutesList.vue?vue&type=script&lang=js&"
import style0 from "./RoutesList.vue?vue&type=style&index=0&id=95102796&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports